module.exports = __webpack_public_path__ + "img/absolut-age-confirm-logo.062cedf8.svg";